export class Item {
    public name: string;
    public object: Phaser.GameObjects.Image;
    public startX: number;
    public startY: number;
    public startWidth: number;
    public startHeight: number;
    public placedWidth: number;
    public placedHeight: number;
    public successfullyPlaced: boolean;
    public polygon: Phaser.Geom.Polygon;
    public currentPolygon: Phaser.Geom.Polygon;

    constructor(name: string, startX: number, startY: number, placedWidth: number, placedHeight: number) {
        this.name = name;
        this.startX = startX;
        this.startY = startY;
        this.placedHeight = placedHeight;
        this.placedWidth = placedWidth;
        this.successfullyPlaced = false;
    }
}



// WEBPACK FOOTER //
// ./src/games/WarehouseGame/objects/Item.ts